import { Box, Stack, Typography, SxProps, Theme } from "@mui/material";
import { primary, text, background, divider } from "@/theme/colors";
import { typography } from "@/theme/typography";
import { FC, ReactNode } from "react";

export type TSettingsCardProps = {
  icon?: ReactNode;
  title?: string;
  children?: ReactNode;
  sx?: SxProps<Theme>;
};

export const SettingsCard: FC<TSettingsCardProps> = ({ icon, title, children, sx }) => {
  return (
    <Stack
      sx={{
        bgcolor: background.white,
        boxShadow: `inset 0 0 0 1px ${divider.middle}`,
        borderRadius: "8px",
        p: 2,
        gap: 2.5,
        boxSizing: "border-box",
        ...sx,
      }}
    >
      {(icon || title) && (
        <Stack direction="row" alignItems="center" gap={1} mb={0.25}>
          {icon && <Box sx={{ color: primary.main, display: "flex" }}>{icon}</Box>}
          {title && <Typography sx={{ ...typography.sub16Bold, color: text.primary }}>{title}</Typography>}
        </Stack>
      )}
      {children}
    </Stack>
  );
};
